var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15886 4.44428V2.6665H16.0557V4.44428H20.5041V6.22206H18.7247V19.5554C18.7247 19.7911 18.631 20.0172 18.4642 20.1839C18.2973 20.3506 18.071 20.4443 17.8351 20.4443H5.3795C5.14354 20.4443 4.91725 20.3506 4.7504 20.1839C4.58355 20.0172 4.48982 19.7911 4.48982 19.5554V6.22206H2.71045V4.44428H7.15886ZM6.26918 6.22206V18.6665H16.9454V6.22206H6.26918ZM8.93823 8.88873H10.7176V15.9998H8.93823V8.88873ZM12.497 8.88873H14.2763V15.9998H12.497V8.88873Z",
    fill: "#7E8285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0d12479a180b9958bf8e69e4975c37c4.svg";
export { ForwardRef as ReactComponent };